module.exports = __webpack_public_path__ + "img/SKMJ_chemicallist1.323f3ce0.png";